import { render, staticRenderFns } from "./SheltaRewardPoint.vue?vue&type=template&id=47fb026e&scoped=true&"
import script from "./SheltaRewardPoint.vue?vue&type=script&lang=js&"
export * from "./SheltaRewardPoint.vue?vue&type=script&lang=js&"
import style0 from "./SheltaRewardPoint.vue?vue&type=style&index=0&id=47fb026e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb026e",
  null
  
)

export default component.exports